module.exports = __webpack_public_path__ + "static/media/logo192.6e4071fd.png";